import React, { useMemo } from 'react';

import { DatePicker } from '@adsk/alloy-react-date-picker';
import {
  displayDate,
  parseDate,
  VALID_DATE_FORMATS,
} from '@adsk/alloy-react-datetime';
import { CalendarFilledIcon } from '@adsk/alloy-react-icon';
import InlineEdit from '@adsk/alloy-react-inline-edit';
import { useLocale } from '@adsk/alloy-react-locale';

import { getLocalDate } from './helpers/utils';

const FormsDatePicker = ({ disabled, formDate, onChange }) => {
  const { locale } = useLocale(({ locale }) =>
    require(`./i18n/${locale}.json`),
  );
  const dateValue = useMemo(() => {
    if (!formDate) return null;

    // Form date values are the same across all timezones: UTC
    const localFormDate = getLocalDate(formDate);
    return parseDate(localFormDate);
  }, [formDate]);

  return (
    <InlineEdit
      disabled={disabled}
      onChange={({ date }) => {
        onChange(Date.parse(date));
      }}
      value={dateValue}
      renderValue={(dateValue) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <CalendarFilledIcon
            size={16}
            style={{
              marginRight: '14px',
            }}
          />
          {dateValue &&
            displayDate(dateValue, {
              format: VALID_DATE_FORMATS.SHORT,
              locale,
            })}
        </div>
      )}
      renderInput={({ value, error, onChange }) => (
        <DatePicker
          initialOpen
          value={value}
          error={error}
          onChange={onChange}
          format={VALID_DATE_FORMATS.SHORT}
          style={{
            width: '100%',
            '&>button': {
              width: 'inherit',
              border: 'none',
            },
          }}
        />
      )}
    />
  );
};

export default FormsDatePicker;
